import {SET_FOOTER} from '../constant'

export const footer = data =>({type:SET_FOOTER,data})